(function () {
  window.ViewsCollectorStack = function (specs) {
    var bodies = {};
    specs.forEach(function (spec, index) {
      var thickness = spec.thickness;
      var mass = .432 * thickness / .027857;
      bodies[spec.id] = { id: spec.id, t: thickness, mass: mass, invMass: 1 / mass, invInertia: 12 / (mass * (.94 * .94 + thickness * thickness)), sign: index % 2 ? -1 : 1, y: 0, v: 0, angle: 0, omega: 0, on: false, pending: false, contacted: true, gap: 0 };
    });
    var order = [], running = false, elapsed = 0, quiet = 0, releaseAt = 0;

    function finish() {
      var offset = 0;
      order.forEach(function (id) {
        var b = bodies[id];
        b.y = -offset;
        b.v = b.angle = b.omega = b.gap = 0;
        b.pending = false;
        b.contacted = true;
        offset += b.t;
      });
      running = false;
    }

    function set(next, animate) {
      var selectedOrder = next.filter(function (id, i) { return bodies[id] && next.indexOf(id) === i; });
      if (animate && selectedOrder.join(',') === order.join(',')) return;
      order = selectedOrder;
      Object.keys(bodies).forEach(function (id) {
        var b = bodies[id], selected = order.indexOf(id) !== -1;
        if (selected && !b.on) { b.pending = !!animate; b.contacted = false; b.v = b.omega = 0; }
        b.on = selected;
        if (!selected) { b.pending = false; b.v = b.omega = 0; }
      });
      if (!animate || !order.length) { finish(); return; }
      elapsed = quiet = 0;
      releaseAt = 0;
      running = true;
    }

    function contact(b, below, x) {
      var surface = below ? below.y + below.angle * x - below.t : 0;
      var penetration = b.y + b.angle * x - surface;
      if (penetration < -.00012) return;
      var inverse = b.invMass + x * x * b.invInertia + (below ? below.invMass + x * x * below.invInertia : 0);
      var relative = b.v + b.omega * x - (below ? below.v + below.omega * x : 0);
      if (relative > 0) {
        var impulse = relative * (relative > .08 ? 1.06 : 1) / inverse;
        b.v -= impulse * b.invMass;
        b.omega -= impulse * x * b.invInertia;
        if (below) { below.v += impulse * below.invMass; below.omega += impulse * x * below.invInertia; }
      }
      if (penetration > .000015) {
        var correction = (penetration - .000015) * .75 / inverse;
        b.y -= correction * b.invMass;
        b.angle -= correction * x * b.invInertia;
        if (below) { below.y += correction * below.invMass; below.angle += correction * x * below.invInertia; }
      }
      if (!b.contacted) { b.contacted = true; releaseAt = elapsed + .055; }
    }

    function integrate(dt) {
      elapsed += dt;
      var live = order.map(function (id) { return bodies[id]; }).filter(function (b) { return !b.pending; });
      var pending = order.map(function (id) { return bodies[id]; }).filter(function (b) { return b.pending; });
      if (pending.length && elapsed >= releaseAt && !live.some(function (b) { return !b.contacted; })) {
        var entering = pending[0], below = live[live.length - 1];
        entering.pending = false;
        entering.y = (below ? below.y - below.t : 0) - .22;
        entering.angle = entering.sign * .052;
        entering.v = .035;
        entering.omega = -entering.sign * .035;
        live.push(entering);
      }
      live.forEach(function (b) {
        b.previousY = b.y;
        b.previousAngle = b.angle;
        b.v += 7 * dt;
        b.v *= Math.exp(-.4 * dt);
        b.omega *= Math.exp(-5 * dt);
        b.y += b.v * dt;
        b.angle += b.omega * dt;
      });
      for (var pass = 0; pass < 14; pass++) {
        live.forEach(function (b, i) {
          contact(b, live[i - 1], -.47);
          contact(b, live[i - 1], .47);
        });
      }
      var stable = !pending.some(function (b) { return b.pending; });
      live.forEach(function (b, i) {
        var base = i ? live[i - 1].y - live[i - 1].t : 0;
        b.gap = Math.max(0, base - b.y);
        if (Math.abs(b.y - b.previousY) > dt * .002 || Math.abs(b.angle - b.previousAngle) > dt * .008 || Math.abs(b.angle) > .0012 || Math.abs(b.y - base) > .0008) stable = false;
      });
      quiet = stable ? quiet + dt : 0;
      if (quiet > .075 || elapsed > 2.4) finish();
    }

    return {
      bodies: bodies,
      set: set,
      finish: finish,
      step: function (seconds) {
        var remaining = Math.min(Math.max(seconds, 0), .05);
        while (running && remaining > .0000001) { var dt = Math.min(remaining, 1 / 240); integrate(dt); remaining -= dt; }
        return running;
      },
      isRunning: function () { return running; }
    };
  };
})();
